import { defineMessages } from "react-intl";

export const prepareCheckoutMessages = defineMessages({
  title: {
    id: "vinzQl",
    defaultMessage: "Prepare a checkout",
    description: "prepare checkout card title",
  },
  description: {
    id: "GlUHrE",
    defaultMessage:
      "Opens the storefront with an empty cart on this customer's account. Add the parts there, then send them the payment link: they pay it themselves.",
    description: "prepare checkout card description",
  },
  button: {
    id: "W0wgQz",
    defaultMessage: "Prepare a checkout",
    description: "prepare checkout button",
  },
  creating: {
    id: "kv75Lt",
    defaultMessage: "Creating…",
    description: "prepare checkout button, working",
  },
  channelLine: {
    id: "c9okrW",
    defaultMessage: "Prices on channel {channel}",
    description: "prepare checkout card, dealer channel line",
  },
  noStorefront: {
    id: "saeoRV",
    defaultMessage: "This store has no storefront URL configured, so a cart cannot be prepared.",
    description: "prepare checkout disabled, no storefront url",
  },
  noEmail: {
    id: "Ov9bpl",
    defaultMessage:
      "This customer has no email address, so there is nowhere to send a payment link.",
    description: "prepare checkout disabled, customer has no email",
  },
  noChannel: {
    id: "H76eSh",
    defaultMessage:
      "This store has several channels and no default-channel, so the cart's channel cannot be chosen here.",
    description: "prepare checkout disabled, no default channel",
  },
  stepFailed: {
    id: "AwfY/a",
    defaultMessage: "{message} The cart {cart} is already open: click Prepare again to finish it.",
    description: "prepare checkout error, a step after the cart was created",
  },
  createFailed: {
    id: "Db3hIR",
    defaultMessage: "The storefront could not create a cart for this customer.",
    description: "prepare checkout error",
  },
  popupBlocked: {
    id: "OqfmG5",
    defaultMessage: "The browser blocked the new tab. Open this link: {url}",
    description: "prepare checkout error, popup blocked",
  },
  addOrder: {
    id: "r5g4xw",
    defaultMessage: "Add order",
    description: "order list button, prepare a checkout for a customer",
  },
  dialogSubtitle: {
    id: "imbLN2",
    defaultMessage:
      "Pick the customer this order is for. The storefront opens with an empty cart on their account.",
    description: "prepare checkout dialog subtitle",
  },
  customerLabel: {
    id: "ZmEaeH",
    defaultMessage: "Customer",
    description: "prepare checkout dialog customer picker label",
  },
  confirm: {
    id: "LVhnoM",
    defaultMessage: "Prepare",
    description: "prepare checkout dialog confirm button",
  },
  freightTitle: {
    id: "Lt/vqX",
    defaultMessage: "Quoted freight",
    description: "prepared cart, freight amount the rep quoted",
  },
  freightHint: {
    id: "8n6rlg",
    defaultMessage:
      "The freight you quoted this customer on the cart just prepared. Checkout offers it as a shipping option on this cart only.",
    description: "prepared cart, quoted freight explanation",
  },
  freightCurrent: {
    id: "O1gx7J",
    defaultMessage: "On this cart: {amount}",
    description: "prepared cart, quoted freight currently set",
  },
  freightNone: {
    id: "CG8O0k",
    defaultMessage: "No quoted freight on this cart.",
    description: "prepared cart, no quoted freight set",
  },
  freightBadAmount: {
    id: "xZmMxb",
    defaultMessage: "Enter an amount above zero with at most 2 decimals.",
    description: "quoted freight error, bad amount",
  },
  freightNotFound: {
    id: "2p9Zm+",
    defaultMessage: "This cart is no longer on this store.",
    description: "quoted freight error, unknown cart",
  },
  freightNotPrepared: {
    id: "Bol+6n",
    defaultMessage: "This cart was not prepared by staff, so freight can't be quoted on it.",
    description: "quoted freight error, cart not prepared",
  },
  freightLocked: {
    id: "fXVuUr",
    defaultMessage: "This quote was already sent; freight can't change.",
    description: "quoted freight error, quote past sent",
  },
  freightUnreachable: {
    id: "G1bmKx",
    defaultMessage: "The store did not answer. Try again.",
    description: "quoted freight error, store unreachable",
  },
  freightFailed: {
    id: "IiwPs8",
    defaultMessage: "The freight could not be saved. Try again.",
    description: "quoted freight error, anything else",
  },
});
